import { isProxyDevBypassEnabled } from '~/shared/utils/proxy-dev-bypass';

export function canAccessProxyClient(sessionIsAdmin?: boolean): boolean {
  if (isProxyDevBypassEnabled()) {
    return true;
  }

  return Boolean(sessionIsAdmin);
}
